import Router from "vue-router";
import Vue from "vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    // redirect: "/",
    component: () => import("@/pages/homePage.vue"),
    meta: { title: "水票中心", icon: "" },
  },
  {
    path: "/login",
    // redirect: "/login",
    component: () => import("@/pages/login.vue"),
    meta: { title: "登录", icon: "" },
  },
  {
    path: "/register",
    // redirect: "/login",
    component: () => import("@/pages/register.vue"),
    meta: { title: "注册", icon: "" },
  },
  {
    path: "/person",
    // redirect: "/person",
    component: () => import("@/pages/personalCenter.vue"),
    meta: { title: "个人中心", icon: "" },
  },
  {
    path: "/list",
    // redirect: "/list",
    component: () => import("@/pages/goodsList.vue"),
    meta: { title: "订单信息", icon: "" },
  },
];

// 将路由对象传入到Vue实例中
export default new Router({
  routes,
  // 此处模式在测试环境中使用hash,正式环境中则改为history
  mode: "history",
});
